import React, { memo } from "react";
import { Skeleton, SkeletonItem } from "@fluentui/react-components";
import styled from "styled-components";

const Wrapper = styled.div`
  padding: 20px;
  width: 100%;
`;

const BannerSkeleton = styled.div`
  display: flex;
  flex-direction: row;
  gap: 20px;
  padding: 20px 0;
`;

const ToolsSkeletonWrapper = styled.div`
  margin-top: 40px;
`;

const TableSkeletonWrapper = styled.div`
  margin-top: 30px;
`;

const HomeSkeleton = () => {
  return (
    <Wrapper>
      {/* Banner Section */}
      <BannerSkeleton>
        <div style={{ flex: 1 }}>
          <Skeleton>
            <SkeletonItem shape="rectangle" size={32} />
          </Skeleton>

          <Skeleton style={{ marginTop: 12 }}>
            <SkeletonItem shape="rectangle" size={20} />
          </Skeleton>

          <Skeleton style={{ marginTop: 12 }}>
            <SkeletonItem shape="rectangle" size={20} />
          </Skeleton>

          <Skeleton style={{ marginTop: 30 }}>
            <SkeletonItem shape="rounded" size={40} />
          </Skeleton>
        </div>

        <Skeleton>
          <SkeletonItem shape="rectangle" size={120} />
        </Skeleton>
      </BannerSkeleton>

      {/* Tools Section */}
      <ToolsSkeletonWrapper>
        <Skeleton>
          <SkeletonItem shape="rectangle" size={30} />
        </Skeleton>

        <div style={{ display: "flex", gap: 10, marginTop: 20 }}>
          {Array.from({ length: 4 }).map((_, i) => (
            <Skeleton key={i}>
              <SkeletonItem shape="rounded" size={80} />
            </Skeleton>
          ))}
        </div>
      </ToolsSkeletonWrapper>

      {/* Table Section */}
      <TableSkeletonWrapper>
        <Skeleton>
          <SkeletonItem shape="rectangle" size={30} />
        </Skeleton>

        {Array.from({ length: 5 }).map((_, i) => (
          <Skeleton key={i} style={{ marginTop: 12 }}>
            <SkeletonItem shape="rectangle" size={40} />
          </Skeleton>
        ))}
      </TableSkeletonWrapper>
    </Wrapper>
  );
};

export default memo(HomeSkeleton);
